import { network } from 'services/network';

export const updateUserGroup = (params) => {
    const userGroup = {
        customer_id: params.customer_id,
        group_name: params.newName,
        projects_list: params.projects_list,
        roles_list: params.roles_list,
    };

    return network.post('admin/bo/updateUserGroup', userGroup).then((response) => response.data);
};
